import { render, staticRenderFns } from "./dsn-left-menu.vue?vue&type=template&id=2e868ffc&"
import script from "./dsn-left-menu.vue?vue&type=script&lang=js&"
export * from "./dsn-left-menu.vue?vue&type=script&lang=js&"
import style0 from "./dsn-left-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports